import { render } from "./NewAwards.vue?vue&type=template&id=d2cb6774"
import script from "./NewAwards.vue?vue&type=script&lang=js"
export * from "./NewAwards.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__